function formatSnizeAttributes() {
  const replacements = {
    "instock": "In Stock",
    "outofstock": "Out of Stock",
    "pre_order": "Preorder",
    "call_for_pricing": "Call for Pricing",
    "discontinued": "Discontinued",
    "confirmation": "In Stock",
    "for_installation": "For Installation",
    "call_to_order": "Call to Order"
  };

  document.querySelectorAll("div.snize-ac-results-content span.snize-attribute").forEach(el => {
    const textNodes = Array.from(el.childNodes).filter(n => n.nodeType === Node.TEXT_NODE);
    textNodes.forEach(node => {
      const trimmed = node.textContent.trim();
      if (replacements.hasOwnProperty(trimmed)) {
        node.textContent = replacements[trimmed];
      }
    });
  });
}

// Run on page load
document.addEventListener("DOMContentLoaded", formatSnizeAttributes);

// Optional: Handle dynamic updates (e.g., autocomplete search results from Snize)
const observer = new MutationObserver(() => {
  formatSnizeAttributes();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

document.addEventListener('DOMContentLoaded', function () {
  if (!window.location.pathname.includes('/interlock-book-appointment')) return;

  console.log("🚦 Watching for form-embed...");

  const carModelMap = {
    "ACURA": ["TSX"],
    "ALFA ROMEO": ["GIULIA", "GIULIETTA", "MITO", "STELVIO"],
    "AUDI": ["A1", "A3", "A4", "A5", "A6", "A7", "Q2", "Q3", "Q5", "Q7", "TT"],
    "BMW": ["1-SERIES", "2-SERIES", "2-SERIES ACTIVE TOURER", "2-SERIES GRAN TOURER", "3-SERIES", "4-SERIES", "5-SERIES", "6-SERIES", "7-SERIES", "I3", "I8", "M2", "X1", "X2", "X3", "X4", "X5", "X6", "Z4"],
    "BUICK": ["CASCADA", "ENCORE", "ENVISION"],
    "CADILLAC": ["CTS", "SRX"],
    "CHEVROLET": ["ASTRA", "AVEO", "CAMARO", "COLORADO", "CRUZE", "EQUINOX", "GRAND VITARA SZ", "MALIBU", "ORLANDO", "S-10", "SONIC", "SPARK", "SS", "TRACKER", "TRAILBLAZER", "TRAX", "VOLT"],
    "CHRYSLER": ["200", "300", "300C", "ASPEN", "GRAND-VOYAGER", "SEBRING", "TOWN AND COUNTRY"],
    "CITRON": ["BERLINGO", "C-ELYSE", "C-ZERO", "C1", "C2", "C3", "C3 AIRCROSS", "C3 PICASSO", "C3 PLURIEL", "C4", "C4 AIRCROSS", "C4 CACTUS", "C4 PICASSO", "C4 SPACETOURER", "C5", "C5 AIRCROSS", "C6", "C8", "DISPATCH", "DS 3", "DS 3 CROSSBACK", "DS 4", "DS 5", "DS 7 CROSSBACK", "GRAND C4 PICASSO", "GRAND C4 SPACETOURER", "JUMPER", "JUMPY", "RELAY", "SPACETOURER", "XSARA PICASSO"],
    "CUPRA": ["ATECA", "BORN", "FORMENTOR", "LEON", "TAVASCAN"],
    "DACIA": ["DOKKER", "DOKKER STEPWAY", "DUSTER", "JOGGER", "LODGY", "LODGY STEPWAY", "LOGAN", "SANDERO", "SANDERO STEPWAY", "SPRING"],
    "DAEWOO": ["REXTON"],
    "DAIHATSU": ["MATERIA", "MIRA", "SIGRA", "SIRION", "TERIOS", "YRV"],
    "DODGE": ["AVENGER", "CALIBER", "CARAVAN", "CHALLENGER", "CHARGER", "DAKOTA", "DART", "DURANGO", "GRAND-CARAVAN", "JOURNEY", "MAGNUM", "NITRO", "RAM", "VIPER"],
    "FIAT": ["124", "500", "500C", "500E", "500L", "500X", "600", "600E", "ABARTH 500", "ABARTH 500E", "DUCATO", "E-DUCATO", "GRANDE PUNTO", "LINEA", "PANDA", "PUNTO", "PUNTO EVO", "SEDICI", "TALENTO", "TIPO"],
    "FORD": ["B-MAX", "C-MAX", "E-TOURNEO CUSTOM", "E-TRANSIT BUSS", "ECOSPORT", "EDGE", "ENDURA", "FALCON", "FIESTA", "FOCUS", "GALAXY", "KA+", "KUGA", "MONDEO", "MUSTANG", "MUSTANG MACH-E", "PUMA", "RANGER", "S-MAX", "TOURNEO", "TOURNEO COURIER", "TOURNEO CUSTOM", "TOURNERO", "TRANSIT", "TRANSIT BUSS", "TRANSIT CONNECT", "TRANSIT COURIER", "TRANSIT CUSTOM", "TRANSIT TOURNEO CONNECT"],
    "GMC": ["TERRAIN"],
    "HOLDEN": ["BARINA", "CASCADA", "COLORADO 7", "COMMODORE", "CRUZE", "SPARK", "TRAILBLAZER", "TRAX", "VOLT"],
    "HONDA": ["ACCORD", "BALLADE", "BR-V", "BREEZE", "CITY", "CIVIC", "CLARITY", "CR-V", "CR-Z", "E", "FIT", "FREED", "HR-V", "INSIGHT", "INSPIRE", "JAZZ", "MOBILIO", "ODYSSEY", "PASSPORT", "PILOT", "RIDGELINE", "SPIRIOR", "STEPWGN"],
    "HYUNDAI": ["ACCENT", "ASLAN", "AVANTE", "AZERA", "BAYON", "CARGO", "CELESTA", "CRETA", "ELANTRA", "ENCINO", "EON", "EQUUS", "GENESIS", "GENESIS G80", "GRAND I10", "GRAND SANTA FE", "GRAND STAREX", "GRANDEUR", "H-1", "H300", "H350", "HB20", "I10", "I20", "I30", "I35", "I40", "I800", "ILOAD", "IMAX", "IONIQ", "IONIQ 5", "IONIQ 6", "IX20", "IX25", "IX35", "IX55", "KAUAI", "KONA", "KONA ELECTRIC", "KX3", "MAXCRUZ", "MISTRA", "NEXO", "PALISADE", "SANTA FE", "SANTRO", "SOLARIS", "SOLATI", "SONATA", "STAREX", "STARIA", "TUCSON", "VELOSTER", "VENUE", "VERACRUZ", "VERNA"],
    "ISUZU": ["AMIGO", "COMO", "D-MAX", "MU-X", "PANTHER", "RODEO", "TROOPER", "VEHICROSS"],
    "IVECO": ["DAILY", "EDAILY"],
    "JEEP": ["CHEROKEE", "COMMANDER", "COMPASS", "GLADIATOR", "GRAND-CHEROKEE", "LIBERTY", "PATRIOT", "RENEGADE", "WRANGLER"],
    "KGM": ["KORANDO", "KORANDO E-MOTION", "MUSSO", "REXTON", "REXTON SPORTS", "TIVOLI"],
    "KIA": ["CADENZA", "CARENS", "CARNIVAL", "CEED", "CERATO", "EV6", "FORTE", "GRAND CARNIVAL", "K2", "K3", "K5", "K7", "KX CROSS", "KX1", "KX3", "KX5", "MORNING", "NIRO", "NIRO EV", "OPTIMA", "PEGAS", "PICANTO", "PRIDE", "PRO_CEE'D", "PROCEED", "RIO", "RONDO", "SEDONA", "SELTOS", "SOLUTO", "SONET", "SORENTO", "SOUL", "SPORTAGE", "STINGER", "STONIC", "TELLURIDE", "VENGA", "XCEED"],
    "LANCIA": ["YPSILON"],
    "LAND ROVER": ["DEFENDER", "DEFENDER 110", "DEFENDER 130", "DEFENDER 90", "DISCOVERY", "DISCOVERY SPORT", "RANGE ROVER", "RANGE ROVER EVOQUE", "RANGE ROVER SPORT", "RANGE ROVER VELAR"],
    "LEXUS": ["ES", "GS", "IS", "NX"],
    "MAN": ["ETGE", "TGE"],
    "MARUTI SUZUKI": ["A-STAR", "ALTO 800", "ALTO K10"],
    "MASERATI": ["GHIBLI", "LEVANTE", "QUATTROPORTE"],
    "MAZDA": ["323", "626", "ATENZA", "BT-50", "CX-5", "CX-7", "CX-9", "DEMIO", "MAZDA 2", "MAZDA 3", "MAZDA 5", "MAZDA 6", "MAZDA 8", "MPV", "MX-5", "PREMACY", "RX-8", "TRIBUTE"],
    "MERCEDES": ["A-CLASS", "B-CLASS", "C-CLASS", "CITAN", "CL-CLASS", "CLA", "CLK-CLASS", "CLS", "E-CLASS", "EQC", "ESPRINTER", "G-CLASS", "GLA", "GLC", "GLE", "GLK-CLASS", "GLS", "M-CLASS", "R-CLASS", "S-CLASS", "SL", "SLK-CLASS", "SPRINTER", "V-CLASS", "VIANO", "VITO", "X-CLASS"],
    "MINI": ["2011 - 2015 (R58)", "CLUBMAN", "COOPER", "COUNTRYMAN", "PACEMAN", "ROADSTER"],
    "MITSUBISHI": ["ASX", "DELICA D:3", "DELICA VAN", "EXPRESS", "OUTLANDER", "OUTLANDER PHEV"],
    "NISSAN": ["350Z", "370Z", "AD", "ALMERA", "ALTIMA", "ARIYA", "ARMADA", "CUBE", "DUALIS", "E-NV200", "EVALIA", "FRONTIER", "GT-R", "INTERSTAR", "JUKE", "KICKS", "LEAF", "LIVINA", "MAGNITE", "MARCH", "MAXIMA", "MICRA", "MICRA C+C", "MURANO", "NAVARA", "NOTE", "NOTE AURA", "NOTE AUTECH CROSSOVER", "NP300", "NV150 AD", "NV1500", "NV200", "NV2500", "NV300", "NV350", "NV3500", "NV400", "PATHFINDER", "PATROL", "PRIMASTAR", "PULSAR", "QASHQAI", "QUEST", "ROGUE", "ROGUE SPORT", "SAKURA", "SENTRA", "SERENA", "SERENA E-POWER", "SKYLINE", "STAGEA", "SYLPHY", "TEANA", "TIIDA", "TITAN", "TOWNSTAR", "WINGROAD", "X-TRAIL", "XTERRA"],
    "OPEL": ["ADAM", "AGILA", "AMPERA", "ASTRA", "CALIBRA", "CASCADA", "COMBO", "CORSA", "CROSSLAND", "CROSSLAND X", "GRANDLAND", "INSIGNIA", "KARL", "MERIVA", "MOKKA", "MOVANO", "SIGNUM", "TIGRA", "TIGRA TWIN TOP", "VECTRA", "VIVARO", "VIVARO-E", "ZAFIRA", "ZAFIRA LIFE", "ZAFIRA TOURER", "ZAFIRA-E LIFE"],
    "PEUGEOT": ["1007", "108", "2008", "206", "207", "208", "3008", "301", "306", "307", "308", "407", "408", "5008", "508", "607", "807", "BOXER", "EXPERT", "PARTNER", "RCZ", "RIFTER", "TRAVELLER"],
    "PONTIAC": ["VIBE"],
    "RAM": ["1500", "2500", "3500", "C/V", "PROMASTER", "PROMASTER CITY", "PROMASTER EV"],
    "RENAULT": ["ALASKAN", "ARKANA", "AUSTRAL", "CAPTUR", "CLIO", "ESPACE", "EXPRESS", "GRAND SCENIC", "KADJAR", "KANGOO", "KOLEOS", "LAGUNA", "MASTER", "MEGANE", "MEGANE E-TECH", "SCENIC", "TALISMAN", "TRAFIC", "TWINGO", "ZOE"],
    "SAAB": ["9-5"],
    "SCANIA": ["G-SERIES", "L-SERIES", "P-SERIES", "PGRT (R-SERIES)", "R-SERIES", "S-SERIES", "XT-RANGE"],
    "SCION": ["FR-S", "IA", "IM", "IQ", "TC", "XA", "XB", "XD"],
    "SEAT": ["ALHAMBRA", "ALTEA", "ARONA", "ATECA", "EXEO", "IBIZA", "LEON", "MII", "TOLEDO"],
    "SKODA": ["CITIGO", "CITIGO-E IV", "ENYAQ IV", "FABIA", "KAMIQ", "KAROQ", "KODIAQ", "KUSHAQ", "OCTAVIA", "PRAKTIK", "RAPID", "ROOMSTER", "SCALA", "SLAVIA", "SUPERB", "YETI"],
    "SMART": ["FORFOUR", "FORTWO"],
    "SSANGYONG": ["ACTYON", "KORANDO", "KORANDO E-MOTION", "KYRON", "LUVI", "MUSSO", "MUSSO SPORTS", "REXTON", "REXTON SPORTS", "RODIUS", "STAVIC", "TIVOLAN", "TIVOLI"],
    "SUBARU": ["BRZ", "CROSSTREK", "FORESTER", "IMPREZA", "LEGACY", "LEVORG", "OUTBACK", "WRX", "XV CROSSTREK"],
    "SUZUKI": ["ACROSS", "AERIO", "ALTO", "BALENO", "BREZZA", "CELERIO", "CIAZ", "DZIRE", "EQUATOR", "ERTIGA", "ESCUDO", "FRONX", "GRAND NOMADE", "GRAND VITARA", "IGNIS", "JIMNY", "KIZASHI", "LANDY", "LIANA", "MR WAGON", "S-CROSS", "S-PRESSO", "SPLASH", "SWACE", "SWIFT", "SWIFT DZIRE", "SX4", "VITARA", "VITARA BREZZA", "WAGON R", "XL-7", "XL6", "XL7"],
    "TOYOTA": ["4-RUNNER", "ALLION", "ALPHARD", "ALTEZZA", "AQUA", "AURION", "AURIS", "AVALON", "AVENSIS", "AVENSIS VERSO", "AYGO", "AYGO X", "BZ4X", "C-HR", "CALYA", "CAMRY", "CELICA", "COROLLA", "COROLLA CROSS", "COROLLA LEVIN", "COROLLA VERSO", "CROWN", "ECHO", "ESQUIRE", "ESTIMA", "ETIOS", "FJ CRUISER", "FORTUNER", "FRONTLANDER", "GRAND HIGHLANDER", "GT86", "HARRIER", "HIACE", "HIGHLANDER", "HILUX", "INNOVA", "IQ", "IST", "IZOA", "LAND CRUISER", "LAND CRUISER PRADO", "MATRIX", "MIRAI", "MR2", "NAV1", "NOAH", "PLATZ", "PREMIO", "PREVIA", "PRIUS", "PRIUS C", "PROACE", "PROACE CITY", "PROACE VERSO", "RAV4", "SEQUOIA", "SIENNA", "SIENTA", "SUPRA", "SW4", "TACOMA", "TARAGO", "TUNDRA", "URBAN CRUISER", "VENZA", "VERSO", "VERSO-S", "VIOS", "VITZ", "VOLTZ", "VOXY", "WILDLANDER", "WISH", "YARIS", "ZELAS"],
    "VAUXHALL": ["ADAM", "AMPERA", "ASTRA", "CALIBRA", "CASCADA", "COMBO", "CORSA", "CROSSLAND", "CROSSLAND X", "INSIGNIA", "KARL", "MERIVA", "MOKKA", "MOVANO", "SIGNUM", "TIGRA", "TIGRA TWIN TOP", "VECTRA", "VIVA", "VIVARO", "VXR8", "ZAFIRA", "ZAFIRA LIFE", "ZAFIRA TOURER"],
    "VOLKSWAGEN": ["ALHAMBRA", "AMAROK", "AMEO", "ARTEON", "ATLAS", "BEETLE", "BORA", "C-TREK", "CADDY", "CALIFORNIA", "CARAVELLE", "CRAFTER", "E-THARU", "E-UP!", "EOS", "GOL", "GOLF", "GOLF PLUS", "GOLF SPORTSVAN", "ID. BUZZ", "ID.3", "ID.4", "ID.5", "ID.6", "ID.7", "JETTA", "LAMANDO", "LAVIDA", "MAGOTAN", "MULTIVAN", "NIVUS", "PASSAT", "PHIDEON", "POLO", "POLO VIVO", "SAGITAR", "SANTANA", "SAVEIRO", "SCIROCCO", "SHARAN", "T-CROSS", "T-ROC", "TACQUA", "TAIGO", "TALAGON", "TAOS", "TAVENDOR", "TAYRON", "TERAMONT", "TERAMONT X", "THARU", "TIGUAN", "TIGUAN ALLSPACE", "TOUAREG", "TOURAN", "TRANSPORTER", "UP!", "VENTO", "VILORAN", "VIRTUS", "VOYAGE"],
    "VOLVO": ["C30", "C40", "C70", "FH TRUCK", "FM TRUCK", "FMX TRUCK", "S40", "S60", "S80", "S90", "V40", "V50", "V60", "V70", "V90", "XC40", "XC60", "XC70", "XC90"]
  };
  
  // find your inline container
  var container = document.querySelector('#shopify-block-AcDJnVjFWYWtYS3RLT__forms_inline_i4AJH7');

  const s = document.createElement('div');
    s.className = 'inline-form-skeleton';
    s.innerHTML = `
      <div class="skeleton-block skeleton-title"></div>
      
      <div class="skeleton-row">
        <div class="skeleton-block"></div>
        <div class="skeleton-block"></div>
        <div class="skeleton-block"></div>
      </div>

      <div class="skeleton-block skeleton-input"></div>
      <div class="skeleton-block skeleton-input"></div>
      <div class="skeleton-block skeleton-input"></div>
      
      <div class="skeleton-block skeleton-input"></div>
      <div class="skeleton-block skeleton-input"></div>
      <div class="skeleton-block skeleton-input"></div>

      <div class="skeleton-row skeleton-phone">
        <div class="skeleton-block"></div>
        <div class="skeleton-block"></div>
      </div>

      <div class="skeleton-block skeleton-button"></div>
    `;
    container.appendChild(s);
    // 🚨 Fallback: Remove skeleton after 5 seconds no matter what
    setTimeout(() => {
      if (document.body.contains(s)) {
        console.warn("🕰️ Removing inline-form-skeleton fallback after 5s timeout");
        s.remove();
      }
    }, 5000);

  const observer = new MutationObserver(() => {
    const formEmbed = document.querySelector('form-embed');
    if (!formEmbed || !formEmbed.shadowRoot) return;

    const shadow = formEmbed.shadowRoot;
    const inlineSection = shadow.querySelector('section._inline_stahb_47');
    if (inlineSection) {
      inlineSection.style.setProperty('overflow', 'visible', 'important');
    }
    
    const noImageSection = shadow.querySelector('._noImage_stahb_161');
    if (noImageSection) {
      noImageSection.style.setProperty('overflow', 'visible', 'important');
    }
    
    const carModelInput = shadow.querySelector('input#rdc\\#car_model');
    const carMakeToggle = shadow.querySelector('button[aria-controls="tdlv#car_make-selector-dropdown"]');
    const makeDropdown = shadow.querySelector('#tdlv\\#car_make-selector-dropdown');
    // const carMakeText = carMakeToggle?.querySelector('span._selectToggleText_1wdej_25');
    const carMakeText = carMakeToggle?.querySelector('span._selectToggleText_12thd_25');
  
    if (!carModelInput || !carMakeToggle || !carMakeText) return;
    if (shadow.querySelector('#custom-car-model')) return;
  
    console.log("✅ Injecting Car Model Selector");
    
    // Function to close all dropdowns
    const closeAllDropdowns = () => {
      // Close the make dropdown
      if (makeDropdown) {
        makeDropdown.style.display = 'none';
      }
      if (carMakeToggle) {
        carMakeToggle.setAttribute('aria-expanded', 'false');
      }
      
      // Close model dropdown if exists
      const modelDropdown = shadow.querySelector('#rdc\\#car_model');
      const modelToggle = shadow.querySelector('#custom-car-model');
      if (modelDropdown) {
        modelDropdown.style.display = 'none';
      }
      if (modelToggle) {
        modelToggle.setAttribute('aria-expanded', 'false');
      }
    };
  
    // Close dropdowns when clicking outside
    document.addEventListener('mousedown', function(e) {
      // Only proceed if we have the shadow root and our custom element exists
      if (!shadow || !shadow.querySelector('#custom-car-model')) return;
      
      // Check if the click was inside any of our dropdown components
      const isClickInsideDropdown = 
        e.target.closest('.form-embed') || 
        shadow.contains(e.target) && (
          e.target.closest('#tdlv\\#car_make-selector-dropdown') || 
          e.target.closest('button[aria-controls="tdlv#car_make-selector-dropdown"]') ||
          e.target.closest('#rdc\\#car_model') || 
          e.target.closest('#custom-car-model')
        );
      
      if (!isClickInsideDropdown) {
        closeAllDropdowns();
      }
    });
    
    // Create hidden input for Car Make if it doesn't exist
    let carMakeInput = shadow.querySelector('input#tdlv\\#car_make');
    if (!carMakeInput) {
      carMakeInput = document.createElement('input');
      carMakeInput.id = 'tdlv#car_make';
      carMakeInput.name = 'tdlv#car_make';
      carMakeInput.type = 'hidden';
      carMakeInput.value = carMakeText.textContent.trim();
      
      // Insert the hidden input after the car make dropdown
      carMakeToggle.parentNode.appendChild(carMakeInput);
      
      // Set up observer for car make changes
      const carMakeObserver = new MutationObserver(() => {
        carMakeInput.value = carMakeText.textContent.trim();
        
        // Trigger change and input events for the make field
        const changeEvent = new Event('change', { bubbles: true });
        const inputEvent = new Event('input', { bubbles: true });
        carMakeInput.dispatchEvent(inputEvent);
        carMakeInput.dispatchEvent(changeEvent);
      });
      
      carMakeObserver.observe(carMakeText, { childList: true, characterData: true, subtree: true });
    }

    // Hide original input and label
    carModelInput.style.display = "none";
    const label = shadow.querySelector('label[for="label-rdc#car_model"]');
    if (label) label.remove();

    // Container
    const container = document.createElement("div");
    container.className = "_selectContainer_1wdej_6";
    container.style.position = "relative";

    // Label
    const newLabel = document.createElement("p");
    newLabel.className = "_label_1wdej_10 _textBody_2aowh_10";
    newLabel.textContent = "Car Model";

    // Toggle button
    const toggle = document.createElement("button");
    toggle.type = "button";
    // toggle.className = "_selectToggle_1wdej_25";
    toggle.className = "_selectToggle_12thd_25";
    toggle.style.position = "relative";
    toggle.id = "custom-car-model"; 
    toggle.setAttribute("aria-expanded", "false");
    toggle.setAttribute("aria-controls", "rdc#car_model");

    const span = document.createElement("span");
    // span.className = "_selectToggleText_1wdej_25";
    span.className = "_selectToggleText_1wdej_25";
    span.textContent = "";

    const arrow = document.createElement("span");
    arrow.className = "_arrowDownIcon_1wdej_19";
    arrow.innerHTML = `<svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.09832 0.470704L0.901685 0.470703C0.15069 0.470703 -0.269991 1.22421 0.193991 1.73831L3.29231 5.17126C3.65265 5.57052 4.34735 5.57052 4.70769 5.17126L7.80601 1.73831C8.26999 1.22421 7.84931 0.470704 7.09832 0.470704Z" fill="#5C5F62"/></svg>`;

    toggle.appendChild(span);
    toggle.appendChild(arrow);

    // Dropdown list
    const dropdown = document.createElement("ul");
    dropdown.id = "rdc#car_model";
    dropdown.style.position = "absolute";
    dropdown.style.top = "100%";
    dropdown.style.left = "0";
    dropdown.style.right = "0";
    dropdown.style.zIndex = "1000";
    dropdown.style.background = "#fff";
    dropdown.style.border = "1px solid #ccc";
    dropdown.style.boxShadow = "0px 4px 8px rgba(0,0,0,0.1)";
    dropdown.style.padding = "0";
    dropdown.style.margin = "4px 0 0 0";
    dropdown.style.display = "none";
    dropdown.style.listStyle = "none";
    dropdown.style.maxHeight = "200px";
    dropdown.style.overflowY = "auto";
    dropdown.style.borderRadius = "4px";

    // Inject into DOM
    container.appendChild(newLabel);
    container.appendChild(toggle);
    container.appendChild(dropdown);
    carModelInput.parentNode.insertBefore(container, carModelInput.nextSibling);

    // Remove error message and fix parent class
    const updateValidationState = () => {
      const errorOutput = carModelInput.parentNode.querySelector('output[role="alert"]');
      if (errorOutput) errorOutput.style.display = 'none';
      
      // Remove error styling from parent container
      const parentContainer = carModelInput.closest('._formFieldContainer_1ydxd_5');
      if (parentContainer && parentContainer.classList.contains('_withError_1ydxd_16')) {
        parentContainer.classList.remove('_withError_1ydxd_16');
      }
    };
    
    // Update dropdown based on Make
    const updateModels = () => {
      const selectedMake = carMakeText.textContent?.trim();

      span.textContent = "";
      carModelInput.value = "";
      dropdown.innerHTML = "";

      if (!carModelMap[selectedMake]) {
        toggle.disabled = true;
        return;
      }

      toggle.disabled = false;

      carModelMap[selectedMake].forEach(model => {
        const li = document.createElement("li");
        li.textContent = model;
        li.style.padding = "8px 12px";
        li.style.cursor = "pointer";

        li.addEventListener("mousedown", (e) => {
          e.preventDefault(); // Prevent focus issues
          span.textContent = model;
          
          // Set the value and trigger proper events
          carModelInput.value = model;
          carModelInput.setAttribute("aria-invalid", "false");
          
          // Trigger change and input events to notify form validation
          const changeEvent = new Event('change', { bubbles: true });
          const inputEvent = new Event('input', { bubbles: true });
          carModelInput.dispatchEvent(inputEvent);
          carModelInput.dispatchEvent(changeEvent);
          
          // Update validation UI
          updateValidationState();
          
          dropdown.style.display = "none";
          toggle.setAttribute("aria-expanded", "false");
        });

        li.addEventListener("mouseenter", () => li.style.background = "#f2f2f2");
        li.addEventListener("mouseleave", () => li.style.background = "transparent");

        dropdown.appendChild(li);
      });
    };

    toggle.addEventListener("mousedown", (e) => {
      e.preventDefault(); // Prevent focus issues
      e.stopPropagation();
      const isOpen = toggle.getAttribute("aria-expanded") === "true";
      
      if (!isOpen) {
        // Close all dropdowns
        closeAllDropdowns();
        
        // Then open this one
        dropdown.style.display = "block";
        toggle.setAttribute("aria-expanded", "true");
      } else {
        dropdown.style.display = "none";
        toggle.setAttribute("aria-expanded", "false");
      }
    });

    // Add specific click handler for car make toggle to close model dropdown
    carMakeToggle.addEventListener("mousedown", (e) => {
      // Close model dropdown when opening make dropdown
      dropdown.style.display = "none";
      toggle.setAttribute("aria-expanded", "false");
    });

    const makeObserver = new MutationObserver(updateModels);
    makeObserver.observe(carMakeText, { childList: true, characterData: true, subtree: true });

    // fade out skeleton
    s.style.transition = 'opacity 0.3s ease';
    s.style.opacity = '0';
    setTimeout(() => s.remove(), 350);
  
    updateModels();
    observer.disconnect();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

// Datepicker Implementation
document.addEventListener('DOMContentLoaded', function() {
  if (!window.location.pathname.includes('/interlock-book-appointment')) return;

  const dateObserver = new MutationObserver(() => {
    const formEmbed = document.querySelector('form-embed');
    if (!formEmbed || !formEmbed.shadowRoot) return;

    const shadow = formEmbed.shadowRoot;

    //rdc
    if (shadow) {
      const style = document.createElement('style');
      style.textContent = `
         @media (min-width: 1024px) {
            form._formFieldset_1nihh_63 {
              flex-wrap: wrap !important;
              flex-direction: initial !important;
            }
        
            ._formFieldset_1nihh_63 > div:not(._formPhoneInputContainer_1ym3p_6) {
              display: flex !important;
              flex-direction: column !important;
              flex: 1 1 45% !important;
            }

            form._formFieldset_1nihh_63 > div:nth-child(1) {
              display: flex !important;
              flex-direction: column !important;
              flex: 1 1 100% !important;
            }
        
            ._formSubmitButton_1nihh_77 {
              display: flex !important;
              flex-direction: row !important;
              flex: 1 1 100% !important;
            }
    
            form._formFieldset_1nihh_63 > div:nth-child(5), form._formFieldset_1nihh_63 > div:nth-child(7), form._formFieldset_1nihh_63 > div:nth-child(13) {
              margin-top: 30px!important;
            }

            form._formFieldset_1nihh_63 > div:nth-child(15) {
              margin-top: 20px;
            }
        
            section._formContainer_stahb_30._grid_stahb_148._noImage_stahb_161 {
              max-width: 640px !important;
              margin-left: auto !important;
              margin-right: auto !important; /* Optional: center the section */
            }

           form._formFieldset_1nihh_63 output {
             display: none;
           }

        }
      `;
      shadow.appendChild(style);

      const fieldset = shadow.querySelector('._formFieldset_1nihh_63');
      const form = fieldset?.closest('form'); // corrected
    
      if (form && fieldset) {
        form.addEventListener('submit', (event) => {
          console.log('inn');
          const outputs = fieldset.querySelectorAll('output._formError_1ydxd_20');
          outputs.forEach(output => {
            console.log(0000);
            output.remove();
          });
    
        });
      }
      
    }
    //end rdc
    const dateInput = shadow.querySelector('input#custom\\#preferred_installation_date');
    
    if (!dateInput || shadow.querySelector('#date-picker-container')) return;
    
    console.log("✅ Injecting Date Picker");

    // Create datepicker container
    const datePickerContainer = document.createElement('div');
    datePickerContainer.id = 'date-picker-container';
    datePickerContainer.style.position = 'absolute';
    datePickerContainer.style.zIndex = '1000';
    datePickerContainer.style.backgroundColor = '#fff';
    datePickerContainer.style.border = '1px solid rgb(224, 224, 224)';
    datePickerContainer.style.borderRadius = '4px';
    datePickerContainer.style.boxShadow = 'rgba(0, 0, 0, 0.15) 0px 4px 12px';
    datePickerContainer.style.padding = '16px';
    datePickerContainer.style.display = 'none';
    datePickerContainer.style.width = '280px';
    datePickerContainer.style.boxSizing = 'border-box';
    datePickerContainer.style.fontFamily = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';
    datePickerContainer.style.top = '100%';
    datePickerContainer.style.marginTop = '4px';
    datePickerContainer.style.pointerEvents = 'auto';

    // Add to DOM right after the input's container
    // const inputContainer = dateInput.closest('._formFieldContainer_1ydxd_5');
    const inputContainer = dateInput.closest('._formFieldContainer_ck6wz_5');
    if (inputContainer) {
      inputContainer.style.position = 'relative';
      inputContainer.appendChild(datePickerContainer);
    }

    // Current date for initialization
    let currentDate = new Date();
    let currentMonth = currentDate.getMonth();
    let currentYear = currentDate.getFullYear();

    // Function to generate the calendar
    function generateCalendar(month, year, view = 'days') {
      // Clear the datepicker
      datePickerContainer.innerHTML = '';
      
      // Month and year navigation
      const header = document.createElement('div');
      header.style.display = 'flex';
      header.style.justifyContent = 'space-between';
      header.style.alignItems = 'center';
      header.style.marginBottom = '20px';
      header.style.pointerEvents = 'auto';
      
      const prevBtn = document.createElement('button');
      prevBtn.innerHTML = '←';
      prevBtn.style.background = 'none';
      prevBtn.style.border = 'none';
      prevBtn.style.cursor = 'pointer';
      prevBtn.style.padding = '8px 12px';
      prevBtn.style.color = '#000';
      prevBtn.style.fontSize = '16px';
      prevBtn.style.pointerEvents = 'auto';
      
      const nextBtn = document.createElement('button');
      nextBtn.innerHTML = '→';
      nextBtn.style.background = 'none';
      nextBtn.style.border = 'none';
      nextBtn.style.cursor = 'pointer';
      nextBtn.style.padding = '8px 12px';
      nextBtn.style.color = '#000';
      nextBtn.style.fontSize = '16px';
      nextBtn.style.pointerEvents = 'auto';

      // Add navigation event listeners
      prevBtn.addEventListener('mousedown', (e) => {
        e.preventDefault();
        e.stopPropagation();
        let newMonth = month - 1;
        let newYear = year;
        if (newMonth < 0) {
          newMonth = 11;
          newYear--;
        }
        currentMonth = newMonth;
        currentYear = newYear;
        generateCalendar(currentMonth, currentYear, 'days');
      });
      
      nextBtn.addEventListener('mousedown', (e) => {
        e.preventDefault();
        e.stopPropagation();
        let newMonth = month + 1;
        let newYear = year;
        if (newMonth > 11) {
          newMonth = 0;
          newYear++;
        }
        currentMonth = newMonth;
        currentYear = newYear;
        generateCalendar(currentMonth, currentYear, 'days');
      });
      
      const monthYearLabel = document.createElement('button');
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      monthYearLabel.textContent = `${monthNames[month]} ${year}`;
      monthYearLabel.style.fontWeight = '500';
      monthYearLabel.style.fontSize = '14px';
      monthYearLabel.style.background = 'none';
      monthYearLabel.style.border = 'none';
      monthYearLabel.style.cursor = 'pointer';
      monthYearLabel.style.padding = '4px 8px';
      monthYearLabel.style.borderRadius = '4px';
      
      monthYearLabel.addEventListener('mouseenter', () => {
        monthYearLabel.style.backgroundColor = '#f5f5f5';
      });
      
      monthYearLabel.addEventListener('mouseleave', () => {
        monthYearLabel.style.backgroundColor = 'transparent';
      });
      
      monthYearLabel.addEventListener('mousedown', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (view === 'days') {
          generateMonthView(year);
        } else if (view === 'months') {
          generateYearView();
        }
      });

      // Add Today button
      const todayBtn = document.createElement('button');
      todayBtn.textContent = 'Today';
      todayBtn.style.background = 'none';
      todayBtn.style.border = '1px solid #ddd';
      todayBtn.style.borderRadius = '4px';
      todayBtn.style.padding = '4px 8px';
      todayBtn.style.fontSize = '12px';
      todayBtn.style.cursor = 'pointer';
      todayBtn.style.marginTop = '8px';
      todayBtn.style.width = '100%';
      todayBtn.style.color = '#666';

      todayBtn.addEventListener('mousedown', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const today = new Date();
        currentMonth = today.getMonth();
        currentYear = today.getFullYear();
        generateCalendar(currentMonth, currentYear);
      });

      if (view === 'days') {
        header.appendChild(prevBtn);
        header.appendChild(monthYearLabel);
        header.appendChild(nextBtn);
        datePickerContainer.appendChild(header);
        
        // Create weekday header
        const weekdays = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
        const weekdaysRow = document.createElement('div');
        weekdaysRow.style.display = 'grid';
        weekdaysRow.style.gridTemplateColumns = 'repeat(7, 1fr)';
        weekdaysRow.style.textAlign = 'center';
        weekdaysRow.style.marginBottom = '8px';
        
        weekdays.forEach(day => {
          const dayElem = document.createElement('div');
          dayElem.textContent = day;
          dayElem.style.padding = '4px';
          dayElem.style.fontSize = '12px';
          dayElem.style.color = '#666';
          dayElem.style.fontWeight = '500';
          weekdaysRow.appendChild(dayElem);
        });
        
        datePickerContainer.appendChild(weekdaysRow);
        
        // Create calendar grid
        const calendarGrid = document.createElement('div');
        calendarGrid.style.display = 'grid';
        calendarGrid.style.gridTemplateColumns = 'repeat(7, 1fr)';
        calendarGrid.style.gap = '2px';
        calendarGrid.style.textAlign = 'center';
        calendarGrid.style.width = '100%';
        calendarGrid.style.boxSizing = 'border-box';
        
        // Calculate first day and days in month for the current month/year
        const firstDay = new Date(year, month, 1).getDay();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        
        // Add empty cells for days before the first day of the month
        let adjustedFirstDay = firstDay === 0 ? 6 : firstDay - 1;
        
        for (let i = 0; i < adjustedFirstDay; i++) {
          const emptyDay = document.createElement('div');
          emptyDay.style.padding = '8px';
          calendarGrid.appendChild(emptyDay);
        }
        
        // Add days of the month
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        for (let day = 1; day <= daysInMonth; day++) {
          const dayElem = document.createElement('div');
          dayElem.textContent = day;
          dayElem.style.padding = '4px';
          dayElem.style.margin = '1px';
          dayElem.style.fontSize = '14px';
          dayElem.style.display = 'flex';
          dayElem.style.alignItems = 'center';
          dayElem.style.justifyContent = 'center';
          dayElem.style.transition = 'all 0.2s ease';
          dayElem.style.width = '28px';
          dayElem.style.height = '28px';
          dayElem.style.boxSizing = 'border-box';
          
          const currentDate = new Date(year, month, day);
          currentDate.setHours(0, 0, 0, 0);
          const isPastDate = currentDate < today;
          
          if (isPastDate) {
            dayElem.style.color = '#ccc';
            dayElem.style.backgroundColor = '#fafafa';
            dayElem.style.cursor = 'not-allowed';
          } else {
            dayElem.style.cursor = 'pointer';
            dayElem.style.borderRadius = '50%';
            
            // Highlight today
            if (day === today.getDate() && month === today.getMonth() && year === today.getFullYear()) {
              dayElem.style.backgroundColor = '#f5f5f5';
            }
            
            // Add click handler only for non-past dates
            dayElem.addEventListener('mousedown', function(e) {
              e.preventDefault();
              e.stopPropagation();
              console.log(`Day ${day} mousedown triggered`);
              
              const formattedDate = `${year}-${padZero(month + 1)}-${padZero(day)}`;
              console.log(`Attempting to set date: ${formattedDate}`);
              
              dateInput.value = formattedDate;
              dateInput.setAttribute('data-selected-date', formattedDate);
              
              // Create and dispatch events
              const events = [
                new Event('input', { bubbles: true, composed: true }),
                new Event('change', { bubbles: true, composed: true }),
                new Event('blur', { bubbles: true, composed: true }),
                new CustomEvent('shopify:field:change', {
                  bubbles: true,
                  composed: true,
                  detail: { field: 'custom#preferred_installation_date', value: formattedDate }
                })
              ];

              // Dispatch all events
              events.forEach(event => {
                dateInput.dispatchEvent(event);
              });

              // Force form validation
              const validationEvent = new CustomEvent('shopify:form:validation', {
                bubbles: true,
                composed: true,
                detail: {
                  field: 'custom#preferred_installation_date',
                  valid: true,
                  value: formattedDate
                }
              });
              dateInput.dispatchEvent(validationEvent);
              
              const label = shadow.querySelector(`label#label-custom\\#preferred_installation_date`);
              if (label) {
                label.style.top = '8px';
                label.style.fontSize = '12px';
              }
              
              datePickerContainer.style.display = 'none';
              
              // Add mutation observer for value changes
              const valueObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                  if (mutation.type === 'attributes' && 
                      (mutation.attributeName === 'value' || dateInput.value === '')) {
                    const storedDate = dateInput.getAttribute('data-selected-date');
                    if (storedDate && dateInput.value !== storedDate) {
                      console.log('Restoring date value:', storedDate);
                      dateInput.value = storedDate;
                      
                      if (label) {
                        label.style.top = '8px';
                        label.style.fontSize = '12px';
                      }
                    }
                  }
                });
              });
              
              valueObserver.observe(dateInput, {
                attributes: true,
                attributeFilter: ['value']
              });
              
              const originalSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
              Object.defineProperty(dateInput, 'value', {
                set: function(val) {
                  const storedDate = this.getAttribute('data-selected-date');
                  if (storedDate && val === '') {
                    console.log('Preventing value clear, restoring:', storedDate);
                    originalSetter.call(this, storedDate);
                  } else {
                    originalSetter.call(this, val);
                  }
                },
                get: function() {
                  return Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').get.call(this);
                }
              });
            });
            
            // Add hover effects only for non-past dates
            dayElem.onmouseenter = function() {
              if (!isPastDate) {
                this.style.backgroundColor = '#e6e6e6';
              }
            };
            
            dayElem.onmouseleave = function() {
              if (!isPastDate) {
                if (day === today.getDate() && month === today.getMonth() && year === today.getFullYear()) {
                  this.style.backgroundColor = '#f5f5f5';
                } else {
                  this.style.backgroundColor = 'transparent';
                }
              }
            };
          }
          
          calendarGrid.appendChild(dayElem);
        }
        
        datePickerContainer.appendChild(calendarGrid);
        datePickerContainer.appendChild(todayBtn);
      } else if (view === 'months') {
        const yearHeader = document.createElement('div');
        yearHeader.style.textAlign = 'center';
        yearHeader.style.marginBottom = '16px';
        yearHeader.style.fontSize = '16px';
        yearHeader.style.fontWeight = '500';
        yearHeader.textContent = year;
        yearHeader.style.cursor = 'pointer';
        
        yearHeader.addEventListener('mousedown', (e) => {
          e.preventDefault();
          e.stopPropagation();
          generateYearView();
        });
        
        datePickerContainer.appendChild(yearHeader);
        
        const monthGrid = document.createElement('div');
        monthGrid.style.display = 'grid';
        monthGrid.style.gridTemplateColumns = 'repeat(3, 1fr)';
        monthGrid.style.gap = '8px';
        monthGrid.style.padding = '8px';
        
        monthNames.forEach((monthName, idx) => {
          const monthBtn = document.createElement('button');
          monthBtn.textContent = monthName.slice(0, 3);
          monthBtn.style.padding = '8px';
          monthBtn.style.border = '1px solid #ddd';
          monthBtn.style.borderRadius = '4px';
          monthBtn.style.background = idx === month ? '#f0f0f0' : 'none';
          monthBtn.style.cursor = 'pointer';
          
          monthBtn.addEventListener('mousedown', (e) => {
            e.preventDefault();
            e.stopPropagation();
            currentMonth = idx;
            generateCalendar(currentMonth, currentYear);
          });
          
          monthGrid.appendChild(monthBtn);
        });
        
        datePickerContainer.appendChild(monthGrid);
        datePickerContainer.appendChild(todayBtn);
      }
    }

    function generateYearView() {
      datePickerContainer.innerHTML = '';
      
      const currentYearIndex = Math.floor(currentYear / 10) * 10;
      const yearGrid = document.createElement('div');
      yearGrid.style.display = 'grid';
      yearGrid.style.gridTemplateColumns = 'repeat(4, 1fr)';
      yearGrid.style.gap = '8px';
      yearGrid.style.padding = '8px';
      
      const yearRange = document.createElement('div');
      yearRange.style.textAlign = 'center';
      yearRange.style.marginBottom = '16px';
      yearRange.style.fontSize = '16px';
      yearRange.style.fontWeight = '500';
      yearRange.textContent = `${currentYearIndex} - ${currentYearIndex + 11}`;
      datePickerContainer.appendChild(yearRange);
      
      for (let i = currentYearIndex; i < currentYearIndex + 12; i++) {
        const yearBtn = document.createElement('button');
        yearBtn.textContent = i;
        yearBtn.style.padding = '8px';
        yearBtn.style.border = '1px solid #ddd';
        yearBtn.style.borderRadius = '4px';
        yearBtn.style.background = i === currentYear ? '#f0f0f0' : 'none';
        yearBtn.style.cursor = 'pointer';
        
        yearBtn.addEventListener('mousedown', (e) => {
          e.preventDefault();
          e.stopPropagation();
          currentYear = i;
          generateMonthView(currentYear);
        });
        
        yearGrid.appendChild(yearBtn);
      }
      
      datePickerContainer.appendChild(yearGrid);
      
      // Add Today button
      const todayBtn = document.createElement('button');
      todayBtn.textContent = 'Today';
      todayBtn.style.background = 'none';
      todayBtn.style.border = '1px solid #ddd';
      todayBtn.style.borderRadius = '4px';
      todayBtn.style.padding = '4px 8px';
      todayBtn.style.fontSize = '12px';
      todayBtn.style.cursor = 'pointer';
      todayBtn.style.marginTop = '8px';
      todayBtn.style.width = '100%';
      todayBtn.style.color = '#666';

      todayBtn.addEventListener('mousedown', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const today = new Date();
        currentMonth = today.getMonth();
        currentYear = today.getFullYear();
        generateCalendar(currentMonth, currentYear);
      });
      
      datePickerContainer.appendChild(todayBtn);
    }

    function generateMonthView(year) {
      generateCalendar(currentMonth, year, 'months');
    }
    
    // Show datepicker on input focus/click
    dateInput.addEventListener('click', (e) => {
      e.stopPropagation();
      datePickerContainer.style.display = 'block';
      generateCalendar(currentMonth, currentYear);
    });
    
    // Close datepicker when clicking outside
    document.addEventListener('mousedown', (e) => {
      // Check if the click was inside the datepicker or its input
      const isClickInside = datePickerContainer.contains(e.target) || e.target === dateInput;
      
      console.log('Click detected:', {
        target: e.target,
        isClickInside,
        datePickerContainer: datePickerContainer,
        dateInput: dateInput
      });
      
      if (!isClickInside) {
        console.log('Closing datepicker - click was outside');
        datePickerContainer.style.display = 'none';
      }
    });
    
    // Prevent input typing and default calendar
    dateInput.setAttribute('readonly', 'readonly');
    
    dateObserver.disconnect();
  });
  
  dateObserver.observe(document.body, { childList: true, subtree: true });
});

// Helper function to pad single digits with a leading zero
function padZero(num) {
  return num < 10 ? `0${num}` : num;
}


